import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-stripe',
  templateUrl: './icon-stripe.component.html',
  styleUrls: ['./icon-stripe.component.scss']
})
export class IconStripeComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit(): void {
  }

}
